import ShipmentEstimator from "components/ShipmentEstimator";
import "./index.scss";

export const ShipmentEstimatorPage = () => {
  return (
    <div>
      <ShipmentEstimator />
    </div>
  );
};
